import React, { PropTypes, Component } from 'react'
import {connect} from 'react-redux'
import SmallHeader from '../../smallheader';
import Body from '../../pagescreen/body';
import PhotoBanner   from '../../pagescreen/photobanner';
// import Scroller   from '../../pagescreen/scroller';
import PageTitle   from '../../pagescreen/pagetitle';
import SiblingsList   from '../../pagescreen/siblingslist';
import Footer from '../../homescreen/footer';
import * as Actions from '../../../store/reducers'
import style from './style.css';

class PagePlain extends Component {
    constructor(props){
        super(props)
        this.state = {post: null}
    }
    componentWillMount() {
      const {topics, match } = this.props
      const { topic_id, post_id } = match.params
      const topic = topics && topics[topic_id]
      if(topic_id && !topic){
        this.props.dispatch(Actions.getTopicPosts({topic_id}))
      }
      if(!topic_id){
        fetch(`https://hawaamagazine.com/posts/${post_id}.json`)
        .then( res => res.json())
        .then( post => this.setState({post: post}) )
      }
    }
    render() {
        const { topics, match } = this.props
        const { topic_id, post_id } = match.params
        const topic = topics && topics[topic_id]
        const page = topic_id 
          ? topic && topic.find(p => String(p.id) === post_id)
          : this.state.post
        console.log({page, topic})
        return (
            <div>
                <SmallHeader backNav={ true } opaque/>
                { null && <PhotoBanner page={ page }/> }
                <div className={ `${style.container}` }>
                    <div className={ `container` } style={{ marginTop: '50px'}}>
                        <PageTitle title={ page && page.title }/>
                        <Body page={ page }/>
                        { null && <SiblingsList parentId={ topic_id } /> }
                    </div>
                </div>
                <Footer slug="frontpage"/>
            </div> 
        )
    }
}

export default connect(s => ({ topics: s.app.topics }))(PagePlain)



// WEBPACK FOOTER //
// ./src/components/layouts/pageplain/index.js